module.exports = __webpack_public_path__ + "img/KMS-J-3.9c3879d0.svg";